<template>
	<div class="ReSelectScheduleServices">	
		<div class="row" v-if="value.rb_service == '1' || hide_rb_service===true">
			<label class="col-form-label col-md-12"><span>Выбрать новую услугу</span></label>

			<div class="col-md-12 d-flex" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать новую услугу"
					v-model="value.bp_id"
					@change="onService"
					:disabled="value.rb_service != '1'"
					:filterable="true"
					:multiple="multi_service_check"
				>
					<el-option
						v-for="(el_opt, el_index) in selServOpts"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
				<base-button type="danger" class="no-border my-0" simple icon @click="value.bp_id = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

			</div>
		</div>
		<div class="row" v-if="this.serveStatus && this.serveStatus.length >0">
			<label class="col-form-label col-md-12"><span>Выбрать статус родительской услуги, при котором запускается новая</span></label>
			<div  class="col-md-12 d-flex">
				<!-- <div class="w-100" style="align-items: center;"></div> -->
					<el-select
						class="w-100 select-primary"
						size="large"                
						placeholder="Выбрать статус"
						v-model="value.status"
						@change="onStatus"
						:filterable="true"
					>
						<el-option
							v-for="(el_opt, el_index) in serveStatus"
							class="select-primary"
							:value="el_opt.label"
							:label="el_opt.label"
							:key="el_index"                    
						>
						</el-option>
					</el-select>
					<base-button type="danger" class="no-border my-0" simple icon @click="value.status = ''; "><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
			</div>
		</div>
		<!-- <div class="row" v-if="this.serveStatus && this.serveStatus.length >0">
			<div class="w-100" style="align-items: center;">
				
			</div>
			<base-button type="danger" class="no-border my-0" simple icon @click="function(){value.days = ''; }"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div> -->
		<div class="row" >
			<label class="col-form-label col-md-12"><span>Количество дней</span></label>
			<div  class="col-md-12 d-flex">
				<base-input
				class="w-100"
				v-model="value.days"
				placeholder="Количество дней"
				type="text"
				></base-input>
			</div>
		</div>

		<div class="row" v-if="this.evn_curator_type && this.evn_curator_type.length >0">
			<label class="col-form-label col-md-12"><span>Выбрать тип ответственного</span></label>
			<div class="col-md-12 d-flex" style="align-items: center;">
				<el-select
					class="w-100 select-primary"
					size="large"                
					placeholder="Выбрать тип ответственного"
					v-model="value.evn_curator_type"
					@change="onCh"
				>
					<el-option
						v-for="(el_opt, el_index) in evn_curator_type"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"                    
					>
					</el-option>
				</el-select>
				<base-button type="danger" class="no-border my-0" simple icon @click="value.evn_curator_type = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>

			</div>
		</div>
		<!-- <div class="row" v-if="value.evn_curator_type=='agent_code'">
			<label class="col-form-label col-md-12"><span>Ввести ID агента</span></label>
			<div  class="col-md-12 d-flex">
				<base-input
				class="w-100"
				v-model="value.evn_curator_code"
				placeholder="Ввести ID агента"
				type="number"
				></base-input>
			</div>
		</div> -->
		<div class="row" v-if="value.evn_curator_type=='agent_code'">
			<label class="col-form-label col-md-12"><span>Ввести ID агента</span></label>
			<div  class="col-md-12 d-flex">

				<ReInputSearchDrop 
					class="w-100"
					:placeholder="'Ввести ID агента'"
					v-model="agent_model"
					:objApiMethod="{'obj':'staff' ,'flt':{'fio':''}}"
					:strApiMethodKey="'fio'"
					v-on:change="OnAjaxListSearch"
				/>
			</div>
			<span class="col-md-12 d-flex">ID выбранного сотрудника: {{value.evn_curator_code}}</span>
		</div>
	</div>
</template>

<script>
/*
1. услуг которую запускать
2. статус текущей услуги при котором запускать
3. срок через который запустить
*/

//Делаем для варианта: на ответсвенного за родительскую услугу, на конкретного ИД агента



import { Tooltip, Select, Option  } from 'element-ui';
import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
// import filterParam from 'src/mixins/filterParam.js';

export default {
	name: 'ReSelectScheduleServices',
	// mixins: [filterParam],
	components: {
		// ReFormPrinter,
		[Tooltip.name]: Tooltip,
		[Option.name]: Option,
		[Select.name]: Select,
		ReInputSearchDrop,
	},
	props: {
		value: {
			type: Object,
			default: function() {
				return {
				// bp_id:'',
				// // stage_id:'',
				// // task_id:'',
				// rb_service:'1',
				// status:'',
				// days: '',
				};
			}
		},
		// value: Object,
		findId: {
			type: String,
			default: '',
		},
		required:{
			type: Boolean,
			default: false
		},
		hide_rb_service:{
			type: Boolean,
			default: false
		},
		multi_service:{
			type: Boolean,
			default: false
		},

	},
	data () {
		return {
			ver: 1,
			objGetParams: {},
			objApiData:{},
			selServOpts: [],
			objCurBp:{},
			serveStatus:[
				{value: 'srv_new',label: 'Новая услуга',},
				{value: 'srv_inwork',label: 'В работе',},
				{value: 'srv_sdelka',label: 'Сделка закрыта',},
				{value: 'srv_arhiv',label: 'В архиве',},
				{value: 'srv_oncontrol',label: 'На контроле',},
			],
			evn_curator_type: [{value:'parent_agent',label: 'Агент из родительской услуги'},{value:'agent_code',label: 'Выбрать агента'}], 
			evn_curator_code: '', //тут код конкретного агента, если в предыдущем поле выбранно agent_code
			//Делаем для варианта: на ответсвенного за родительскую услугу, на конкретного ИД агента
			// objCurStage:{},
			// masTaskOpts: [],
			temVal: '',
			agent_model: {
				inputText: '',
				selectedVal: '',
			},
		}
	},
	computed: {
		rb_services(){return this.value.rb_service;},
		multi_service_check: function(){
			if(this.multi_service === true) {return true;} else {return false;}
		},
		// agent_model(){return this.value.evn_curator_code;},
	},
	watch:{
		rb_services(val){
			if(this.value.rb_service == '2' || this.value.rb_service == '0'){
				this.value.bp_id = '';
				// this.value.stage_id = '';
				// this.value.task_id = '';
			}
		},
		// agent_model(val){

		// }
		
	},
	methods: {
		onService(bp_id,bForce=false){
			if(this.multi_service === false){
				for (let i = 0; i < this.objApiData.length; i++) {
					if(this.objApiData[i].id == bp_id){
						this.selStageOpts = [];
						// this.masTaskOpts = [];
						// this.value.stage_id = '';
						// this.value.task_id = '';
						this.objCurBp = this.$GVO.unlinkObject(this.objApiData[i]);
						// for (let s = 0; s < this.objApiData[i].stages.length; s++) {
						// 	this.selStageOpts.push({'value':this.objApiData[i].stages[s].id.toString(),'label':this.objApiData[i].stages[s].name});
						// }
					}
				}
			} else {

			}
		},
		onStatus(status){

		},
		getBPList(){
			this.objGetParams = this.$GVO.GetAllGet();
			this.$GVO.ApiCall('GET',{obj:'BP',flt:{'list':true/*,'archived':true,'only_act':true*/}})
			// this.$GVO.ApiCall('GET',{obj:'BP',flt:{'cascade':true/*,'archived':true,'only_act':true*/}})
			.then((objApi) => {
				if(objApi.success === true){
					this.selServOpts = [];
					//console.log(objApi);
					this.objApiData=objApi.data.BP_DATA;
					for (let i = 0; i < objApi.data.BP_DATA.length; i++) {
						this.selServOpts.push({'value':objApi.data.BP_DATA[i].id.toString(),'label':objApi.data.BP_DATA[i].name});
					}
					if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === false) this.value.bp_id = this.objGetParams['bp_id'];
					if(typeof this.objGetParams['bp_id'] !='undefined' && this.objGetParams['bp_id'] != '' && this.multi_service === true) this.value.bp_id = this.objGetParams['bp_id'].split(',');
					if (this.value.bp_id != '' ) {this.onService(this.value.bp_id,true);} 

					// if(typeof this.objGetParams['stage_id'] !='undefined' && this.objGetParams['stage_id'] != '') this.value.stage_id = this.objGetParams['stage_id'];
					// if (this.value.stage_id != '') {
					// 	//this.onStage(this.value.stage_id);
					// }
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		OnAjaxListSearch(opt){
			//console.log(opt.selectedVal);
			// this.$emit('input', opt.selectedVal);
			this.value.evn_curator_code = opt.selectedVal;
		},
		onCh(evt){
			// console.log(evt);
			if(evt == 'parent_agent'){
				this.value.evn_curator_code = 0;	
				this.agent_model = {
					inputText: '',
					selectedVal: '',
				};
			}
		},
		
	},
	mounted() {
		this.getBPList();
	}
}
</script>
<style scoped>
	.white-content .el-input input::placeholder {color:#222a42;} 
	.white-content .form-options-group  >>> .el-input__inner::placeholder {color:#222a42;} 
	.row{margin-bottom: 10px;}
	.row.select{
		flex-wrap: nowrap;
		margin-right: 0;
		margin-left: 0;
	}
	.row.select>*{padding: 0px;}
	.ReSelectScheduleServices {
		border: 1px dashed #01B0E0; border-radius: 6px; padding: 10px;
	}

</style>
